/**
 * Builds a headers object and conditionally adds an Authorization bearer.
 *
 * @param {HeadersInit} baseHeaders - Optional starting headers (e.g. Content-Type, Sylius-Channel).
 * @param {string | undefined} token - Raw bearer token (without the "Bearer " prefix) or undefined.
 * @returns {HeadersInit} A new headers object with Authorization set when a token exists.
 */
export function addAuthorizationHeader(
  baseHeaders: HeadersInit = {},
  token?: string | null,
): HeadersInit {
  const headers: HeadersInit = { ...baseHeaders };

  if (token && token.trim() !== '') {
    // Avoid double-prefixing if caller accidentally includes "Bearer "
    const formatted = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    (headers as Record<string, string>).Authorization = formatted;
  }

  return headers;
}
